"use client";

import { ICONS_MODULES_PATHS } from "components/Layout/Sidebar/components/body/content/utils/iconModulesPath";
import { ExplorePersonRowV2 } from "components/ui/v2/explore/bundle/ExplorePersonRowV2";
import { ExploreRankingModalV2 } from "components/ui/v2/explore/ExploreRankingModalV2";
import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";
import { IUser } from "types/User.types";

export interface UsersCertificatedModalV2Props {
  open: boolean;
  onClose: () => void;
  data: IUser[];
}

export function UsersCertificatedModalV2({
  open,
  onClose,
  data,
}: UsersCertificatedModalV2Props) {
  const { t } = useTranslation("celebration");

  const description = useMemo(() => {
    if (data.length === 0) return undefined;
    return `${data.length} ${t("usuarios")}`;
  }, [data.length, t]);

  return (
    <ExploreRankingModalV2
      open={open}
      onClose={onClose}
      title={t("Nuevos certificados")}
      iconSrc={ICONS_MODULES_PATHS.CONFIG.CERTIFICATE}
      description={description}
    >
      <div className="flex flex-col gap-1">
        {data.map((user) => (
          <ExplorePersonRowV2
            key={`${user.id}_certificates_modal`}
            user={user}
            secondaryLine={[user.email, user.role?.name?.toLowerCase()]
              .filter(Boolean)
              .join(" · ")}
          />
        ))}
      </div>
    </ExploreRankingModalV2>
  );
}

export default UsersCertificatedModalV2;
